import fieldMapping from '../fieldMappings/poSearchFieldMapping';

export default {
  [fieldMapping.PURCHASE_ORDER_NUMBER]: {
    primary: fieldMapping.PURCHASE_ORDER_NUMBER,
    secondary: '',
    type: 'numeric',
    link: false,
    label: 'Purchase Order Number',
    wrap: true,
    numeric: 'true',
    disablePadding: false
  },
  [fieldMapping.PO_LINE_ITEM_NUMBER]: {
    primary: fieldMapping.PO_LINE_ITEM_NUMBER,
    secondary: '',
    type: 'string',
    link: false,
    label: 'Line Item Number',
    wrap: true,
    numeric: 'false',
    disablePadding: false
  },
  [fieldMapping.VENDOR_CODE]: {
    primary: fieldMapping.VENDOR_CODE,
    secondary: '',
    type: 'string',
    link: false,
    label: 'Vendor Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false
  },
  [fieldMapping.MANUFACTURING_CODE]: {
    primary: fieldMapping.MANUFACTURING_CODE,
    secondary: '',
    type: 'string',
    link: false,
    label: 'Manufacturing Location Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false
  },
  proposedManufacturingCode: {
    primary: 'proposedManufacturingCode',
    secondary: '',
    type: 'string',
    link: false,
    label: 'Proposed Manufacturing Location Code',
    wrap: true,
    numeric: 'false',
    disablePadding: false
  }
};
